<template>
  <div class="user-action-card">
    <div class="top">
      <div class="action-name">行为类型：{{ behaviorItem.item_type_desc }}</div>
    </div>
    <div class="content">
      {{ behaviorItem.detail }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    behaviorItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.user-action-card {
  margin-top: 12px;
  padding: 12px;
  border-radius: 1px;
  border: 1px solid #dedede;
  &:first-child {
    margin-top: 0;
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #222222;
    line-height: 20px;
    .action-name {
      font-weight: 600;
    }
    .action-date {
      font-size: 12px;
      color: rgba(34, 34, 34, 0.45);
      line-height: 18px;
    }
  }
  .content {
    margin-top: 6px;
    font-size: 14px;
    color: #222222;
    line-height: 20px;
  }
}
</style>
